<mat-card class="kpi-card">

  <div class="kpi-header">

    <div class="kpi-icon" [style.background]="iconColor">
      <mat-icon>{{icon}}</mat-icon>
    </div>

    <div class="kpi-content">
      <div class="kpi-title">{{title|traduccion}}</div>
      <div class="kpi-value">{{value}}</div>
      <div class="kpi-trend"></div>
    </div>

  </div>

  <mat-divider *ngIf="footerText"></mat-divider>

  <div class="kpi-footer" *ngIf="footerText">

    <mat-icon *ngIf="footerIcon">{{footerIcon}}</mat-icon>

    <span>{{footerText}}</span>

  </div>

</mat-card>